module.exports = __webpack_public_path__ + "images/no-avatar-company-60x60.71706ead.svg";